/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import favicon16 from "../images/favicon/favicon-16x16.png";
import favicon32 from "../images/favicon/favicon-32x32.png";
import appleTouchIcon from "../images/favicon/apple-touch-icon.png";
import maskIcon from "../images/favicon/safari-pinned-tab.svg";

function SEO({ description, lang, meta, title }) {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                    }
                }
            }
        `
    )

    const metaDescription = description || site.siteMetadata.description

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={`%s | ${site.siteMetadata.title}`}
            link={[
                { rel: "apple-touch-icon", sizes: "180x180", href: `${appleTouchIcon}` },
                { rel: "icon", type: "image/png", sizes: "32x32", href: `${favicon32}` },
                { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon16}` },
                { rel: "mask-icon", color: "#5bbad5", href: `${maskIcon}` },
                { name: "msapplication-TileColor", content: "#da532c" },
                { name: "theme-color", content: "#fff" },
            ]}
            meta={[
                {
                    name: `robots`,
                    content: `noindex, nofollow`,
                },
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata.author,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
            ].concat(meta)}
        />
    )
}

SEO.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
}

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default SEO
